module.exports = __webpack_public_path__ + "img/商品空白图.e597aab5.png";